import { render, staticRenderFns } from "./PosUserMngmt.vue?vue&type=template&id=c64c0608&scoped=true&"
import script from "./PosUserMngmt.vue?vue&type=script&lang=js&"
export * from "./PosUserMngmt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64c0608",
  null
  
)

export default component.exports